import styled from "styled-components";
import Button from "components/Button";

export const ExportButton = styled(Button)`
  border-radius: 8px;
  padding-right: 16px;
  padding-left: 16px;
`;
